export default __webpack_public_path__ + "static/media/stewed.a0e7ab2f.png";